<template>
    <q-select
        outlined
        :modelValue="modelValue"
        :label="label"
        @update:modelValue="$emit('update:modelValue', $event)"
        use-input
        hide-selected
        fill-input
        input-debounce="0"
        :options="options"
        :error="error"
        :loading="loading"
        :disable="loading"
        @filter="filterFn"
        emit-value
        map-options
    >
        <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps">
                <q-item-section>
                    <q-item-label>{{ scope.opt.label }}</q-item-label>
                    <q-item-label caption>{{ scope.opt.value }}</q-item-label>
                </q-item-section>
            </q-item>
        </template>
        <template v-slot:no-option>
            <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
        </template>
        <template v-slot:error>
            <span v-for="err in errors" :key="err">{{ err }}</span>
        </template>
        <template v-for="(_, slot) in $slots" v-slot:[slot]="scope">
            <slot :name="slot" v-bind="scope || {}" />
        </template>
    </q-select>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import PaisService from "@/services/PaisService";
const props = defineProps({
    modelValue: [String, Number, Object],
    errors: [String, Array],
    label: [String],
});
defineEmits(["update:modelValue"]);
const options = ref([]);
let defaultOptions = [];
const error = computed(() => props.errors && props?.errors?.length !== 0);
const loading = ref(false);
const filterFn = (val, update) => {
    update(() => {
        const needle = val.toLowerCase();
        options.value = defaultOptions.filter(
            (v) => v.label.toLowerCase().indexOf(needle) > -1
        );
    });
};
onMounted(async () => {
    loading.value = true;
    defaultOptions = await PaisService.index();
    options.value = defaultOptions;
    loading.value = false;
});
</script>
